export const  GET_USER_IN_SESSION_REQUEST='userInSessionsReducer/GET_USER_IN_SESSION_REQUEST';
export const  GET_USER_IN_SESSION_SUCCESS='userInSessionsReducer/GET_USER_IN_SESSION_SUCCESS';
export const  GET_USER_IN_SESSION_FAILED='userInSessionsReducer/GET_USER_IN_SESSION_FAILED';